import React from 'react';
import PropTypes from 'prop-types';
import {Modal} from 'support/modals';

export default class Confirm extends Modal {

    renderFooter() {
        const {confirm, cancel, cancelClassNames, confirmClassNames} = this.props;

        return (
            <div className='modal-footer action-footer'>
                <button className={cancelClassNames}
                        onClick={() => this.resolve(false)}>{cancel}</button>
                <button className={confirmClassNames}
                        onClick={() => this.resolve(true)}>{confirm}</button>
            </div>
        );
    }

    resolve(resolve) {
        resolve ?
            this.resolveAwait() :
            this.rejectAwait();

        this.close(true);
    }

    confirm = () => {
        this.open();

        return new Promise((resolve, reject) => {
            this.resolveAwait = resolve;
            this.rejectAwait  = reject;
        });
    }

}

Confirm.propTypes = {
    ...Modal.propTypes,
    useOperation:      PropTypes.bool,
    confirm:           PropTypes.string,
    cancel:            PropTypes.string,
    cancelClassNames:  PropTypes.string,
    confirmClassNames: PropTypes.string,
};

Confirm.defaultProps = {
    ...Modal.defaultProps,
    useOperation:      true,
    confirm:           'Confirm',
    cancel:            'Cancel',
    cancelClassNames:  'btn btn-outlinePrimary',
    confirmClassNames: 'btn btn-primary ml-4',
};
